import { Injectable } from '@angular/core';
import { IToasterConfig } from '@interfaces/common';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private toastr: ToastrService) { }

  private _getToasterConfig(){
    let toastConfigObj: IToasterConfig = <IToasterConfig>{};
    let positionClass = 'toast-top-full-width';
    toastConfigObj.positionClass = positionClass;
    toastConfigObj.timeOut = 5000;
    return toastConfigObj;
  }

  showNotification(type: string, message: string = '', config:any = {}){
    let configObj: IToasterConfig = {...this._getToasterConfig(), ...config};
    if(type === 'success'){
      this.toastr.success(message, '', configObj);
    }else if(type === 'error'){
      this.toastr.error(message, '', configObj);
    }else if(type === 'info'){
      this.toastr.info(message, '', configObj);
    }
  }
}
